declare global {
  interface Window {
        parentIFrame: any; // eslint-disable-line
  }
}

export default function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });

  const parentIFrame = window.parentIFrame || null;
  if (parentIFrame) {
    parentIFrame.scrollTo(0, 0);
  }
}
